__turbopack_context__.v({
  "dropdownMenu": "dropdown-menu-module-scss-module__ik-gmG__dropdownMenu",
  "dropdownMenuContainer": "dropdown-menu-module-scss-module__ik-gmG__dropdownMenuContainer",
  "u-animation-bounce": "dropdown-menu-module-scss-module__ik-gmG__u-animation-bounce",
});
